import { render, staticRenderFns } from "./CopyStakeWhitelistGameDialog.vue?vue&type=template&id=edf67836&lang=pug"
import script from "./CopyStakeWhitelistGameDialog.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWhitelistGameDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWhitelistGameDialog.vue?vue&type=style&index=0&id=edf67836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VForm,VRow})
